export const ADD_ERROR = 'errors:add'
export const REMOVE_ERROR = 'errors:remove'
